import { NewProjectAction } from '@/components/header/actions/projects'
import { withNamespaces } from '@/i18n/route-namespaces'

const importProjectsList = () =>
  import('@/pages/dashboard/sessions/projects/list')

export const projectsRoutes = {
  path: 'projects',
  lazy: withNamespaces(['bots', 'projects'], async () => {
    const { ProjectsSession } = await import(
      '@/pages/dashboard/sessions/projects'
    )

    return { Component: ProjectsSession }
  }),
  children: [
    {
      index: true,
      lazy: withNamespaces(['bots', 'projects'], async () => {
        const { ProjectsList } = await importProjectsList()

        return { Component: ProjectsList }
      }),
      handle: {
        action: <NewProjectAction />,
      },
    },
    {
      path: 'edit',
      lazy: withNamespaces(['bots', 'projects'], async () => {
        const { ProjectsList } = await importProjectsList()

        return { Component: ProjectsList }
      }),
    },
  ],
}
